<template>
  <v-row>
    <v-dialog
    v-model="show"
      scrollable
      persistent
      max-width="500px"
    >
      <v-card>
        <v-card-text class="mt-8">
            <v-text-field
            v-model="stornoInvoice.stornoNumber"
            v-bind:label="$t('number')">
            </v-text-field>
            <v-textarea
            v-model="stornoInvoice.stornoComment"
            v-bind:label="$t('comment') +'*'"
                auto-grow
                outlined>
            </v-textarea>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
        <v-btn
            color="blue darken-1"
            text
            @click="saveComment"
          >
            {{ $t('save') }}
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="closeDialog"
          >
            {{ $t('cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
    export default {
        name: "StornoDialog",
        props: ['stornoInvoice'],
        data () {
        return {
            show: false,
            resolve: null
            }
        },
        methods: {
            async showDialog() {
                return new Promise(resolve => {
                this.resolve = resolve
                this.show = true
                })
            },
            saveComment() {
                if(this.stornoInvoice.stornoComment.length > 0){
                    this.show = false
                    this.resolve && this.resolve('ok')
                }
                else
                this.$root.displayNotificationMsg(this.$t('commentRequired'), 'warning')
            },
            closeDialog() {
                this.stornoInvoice.stornoComment = ""
                this.show = false
                this.resolve && this.resolve('storno')
            }
        }
    }
</script>   